<div style="text-align: center;margin-bottom: 3%;"><span style="font-size: x-large;font-weight: 500;">{{"Pre-Inspection Checklist" | translate | async}}</span></div>
<div>
  <table class="table table--full-width table--striped" style="    margin-top: 9px;">
      <thead>
        <tr>
          <th></th>
          <th>{{"Question" | translate | async}}</th>
          <th>{{"Answer" | translate | async}}</th>
          <th>{{"Photo" | translate | async}}</th>
          <th>{{"Comment" | translate | async}}</th>
        </tr>
      </thead>
      <tbody *ngIf=" PreChecklistAnswers?.length > 0">
        <tr *ngFor="let pre of PreChecklistAnswers">
          <td></td>
          <td>{{pre.Question}} </td>
          <td style="width: 100px;"> 
            <mat-form-field style="width: 100px;">        
              <mat-select  #checklistAnswer  [(ngModel)]="pre.Answer" (selectionChange)="ChangeCheckListAnswer(pre.ChecklistAnswerId,$event)">
                <mat-option [value]="-1">{{'N/A' | translate | async}}</mat-option>
                <mat-option [value]="0">{{'NO' | translate | async}}</mat-option>
                <mat-option [value]="1">{{'YES' | translate | async}}</mat-option>
              </mat-select>
            </mat-form-field>
           </td>
          <td>
            <span *ngFor="let image of pre.Images">
              <img class="observation-image__photo" (click)="viewObservationImage(image, pre)" *ngIf="image?.Image" [src]="getImage(image?.Image)" >
            </span>
            <photos-modal [preChecklist]="pre" [ChecklistId]="pre.ChecklistAnswerId"  [comingFrom]="12"  (onPhotoUpload)="photoRecevied($event, pre,imageID)"></photos-modal>
          </td>
          <td>
            <observation-comments [preChecklist]="pre"  [comingFrom]="3"  [IspreChecklist]="true" (onCommentChange)="commentChanged($event,pre)"></observation-comments>
          </td>
        </tr>
      </tbody>
  </table>
</div>